// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__YnbF+","check":"checkbox_check__4mjZ-","checkmark":"checkbox_checkmark__ffi+K","red":"checkbox_red__MOWfp"};